import { CFindEmbeddedSignupForm } from "@/components/signup/bxp-ui-signup/src/components/signup-form/embedded-variants/cfind-embedded-signup.tsx";
import { ProductKey, Bundle } from "@/components/signup/utils";

import { SiteNameContextProvider } from "../site-name-form/site-name-context.tsx";

import {
    LoggedInForm,
    ConfluenceFeaturesPageEmbeddedSignupForm,
    DefaultEmbeddedSignupForm
} from "./embedded-variants";
import { SignupAnalyticsContext, useSignupFormContext } from "./hooks";

export type ConfluenceAnchorVariant =
    | "paid-lp-conf-features"
    | "paid-lp-confl-projectmgmt"
    | "paid-lp-confl-documentation"
    | "paid-lp-confl-template"
    | "anchor-lp-conf-automation"
    | "anchor-lp-conf-collaboration"
    | "anchor-lp-conf-teamwork"
    | "anchor-lp-conf-work-management"
    | "anchor-lp-conf-competitors"
    | "default"
    | "confluence-default";

type EmbeddedSignupFormProps = {
    bundle?: Bundle;
    isUserLoggedIn?: boolean;
    variantOverride?: ConfluenceAnchorVariant;
};

const variants = {
    "paid-lp-conf-features": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-conf-features" />
    ),
    "paid-lp-confl-projectmgmt": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-projectmgmt" />
    ),
    "paid-lp-confl-documentation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-documentation" />
    ),
    "paid-lp-confl-template": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-template" />
    ),
    "anchor-lp-conf-automation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-automation" />
    ),
    "anchor-lp-conf-collaboration": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-collaboration" />
    ),
    "anchor-lp-conf-teamwork": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-teamwork" />
    ),
    "anchor-lp-conf-work-management": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-work-management" />
    ),
    "anchor-lp-conf-competitors": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-competitors" />
    ),
    "default": <DefaultEmbeddedSignupForm />,
    "confluence-default": <CFindEmbeddedSignupForm />
};

export const EmbeddedSignupForm = ({
    bundle,
    isUserLoggedIn,
    variantOverride
}: EmbeddedSignupFormProps) => {
    const { productKey, productName } = useSignupFormContext();

    if (isUserLoggedIn && bundle) {
        return (
            <SiteNameContextProvider productKey={productKey}>
                <LoggedInForm />
            </SiteNameContextProvider>
        );
    }

    let variantName: ConfluenceAnchorVariant = "default";

    if (productKey === ProductKey.CONFLUENCE) {
        variantName = "confluence-default";
    }

    if (variantOverride) {
        variantName = variantOverride;
    }

    return (
        <SignupAnalyticsContext productName={productName}>
            {variants[variantName]}
        </SignupAnalyticsContext>
    );
};
